import { Component } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { IFilterProperty } from '../../../../../shared/interfaces/filters/filter-property.interface';
import { FilterRule } from '../../../../../shared/interfaces/filters/filter-rule.type';
import { FilterOptionComponent } from '../filter-option/filter-option.component';

@Component({
  standalone: false,
  selector: 'suvo-bi-keywords-filter-option',
  templateUrl: './keywords-filter-option.component.html',
  styleUrls: ['./keywords-filter-option.component.scss'],
})
export class KeywordsFilterOptionComponent extends FilterOptionComponent {
  constructor() {
    super();

    this.formGroup = new FormGroup({
      keywords: new FormControl(),
    });
    this.hookForm(this.formGroup);
  }

  hookForm(formGroup: FormGroup) {
    formGroup.valueChanges
      .pipe(debounceTime(100), takeUntil(this.unsubscribe$))
      .subscribe((values: any) => {
        this.option.filterRules = this.getFilterRules(values);
        this.rulesChanged.emit();
      });
  }

  getFilterRules(values: { keywords: string }): FilterRule[] {
    const { keywords } = values;

    if (!keywords) {
      return [];
    }

    const key = this.option.filterPropertyKeys[0];

    const property: IFilterProperty = {
      key,
      in: keywords || '',
      useForSearch: this.option.filterMethodConfig.useForSearch,
    };

    return [property];
  }

  async patchRules(rules: FilterRule[]) {
    if (rules?.length) {
      const property = rules[0] as IFilterProperty;
      this.formGroup.controls.keywords.patchValue(property.in, {
        emitEvent: false,
      });
    } else {
      this.formGroup.controls.keywords.patchValue(null, { emitEvent: false });
    }
  }
}
